
<template>
  <div class="card inventory-lookup">
    <div class="card__header">
      <h2>Ground Shipping Management</h2>
    </div>
    <div class="card__body">
      <el-row :gutter="24">
        <el-col :span="10">
          <div v-if="ground_shipping_only_success === true" class="alert alert-success">{{ ground_shipping_only_on_message }}</div>
          <div v-if="ground_shipping_only_success === false && (ground_shipping_only_on_message || ground_shipping_only_on_message.length > 0)" class="alert alert-danger">{{ ground_shipping_only_on_message }}</div>
          <input
              type="checkbox"
              name="ground_shipping_only_on"
              v-model="isChecked"
              @click="toggleShippingOnlyOn"
          />
          <div v-if="success === true" class="alert alert-success">
            File has been successfully imported!
          </div>
          <div v-if="message !== ''" class="alert alert-danger">
            {{message}}
          </div>
          <p>Records: {{records}}</p>
          Last Upload: {{last_upload}}
          <form @submit="formSubmit" enctype="multipart/form-data" ref="addImageForm">
            <input id="fileUpload" type="file" class="form-control" v-on:change="onChange" style="opacity: 0" ref="fileupload">
            <p>File: {{ filename }}</p>
            <el-button type="primary" @click="chooseFile">Choose</el-button>
            <el-button type="primary" @click="formSubmit">Upload</el-button>
            <input type="hidden" id="setting_name_hidden" v-model="settingName">
            <el-button type="primary" @click="resetForm">Cancel</el-button>
          </form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "../../repositories";
export default {
  mounted() {
    this.loadLastestResults();
    this.fetchInitialValue().then(initialValue => {
      this.isChecked = initialValue; // Update isChecked based on the fetched value
    });
  },
  data() {
    return {
      settingName: 'ground_shipping_states',
      file: '',
      success: false,
      filename: '',
      records: '',
      last_upload: '',
      message: '',
      ground_shipping_only_on_message: '',
      isChecked: false,
      ground_shipping_only_success: false,
    };
  },
  methods: {
    async fetchInitialValue() {
      try {
        const response = await axios.get('/admin-settings/get-admin-setting/ground_shipping_only_on');
        return response.data.value;
      } catch (error) {
        console.error(error);
        this.message = 'Failed to fetch initial value.';
      }
    },
    toggleShippingOnlyOn(event) {
      const isChecked = event.target.checked;
      axios.post('/admin-settings/update-setting', {
        setting_name: 'ground_shipping_only_on',
        value: { value: isChecked },
      })
          .then(response => {
            if (response.data.success) {
              this.ground_shipping_only_on_message = 'Setting updated successfully.';
              this.ground_shipping_only_success = true;
              setTimeout(() => {
                this.ground_shipping_only_success = false;
                this.ground_shipping_only_on_message = '';
              }, 5000);
            } else {
              console.error(response.data);
              this.ground_shipping_only_on_message = 'No such setting found';
            }
          })
          .catch(error => {
            console.error(error);
            this.ground_shipping_only_on_message = 'Failed to update setting.';
          });
    },
    loadLastestResults() {
      let existingObj = this;
      axios.get('/ground-shipping/').then(function (response) {
        existingObj.records = response.data.records;
        existingObj.last_upload = response.data.last_upload;
      });
    },
    chooseFile() {
      document.getElementById("fileUpload").click()
    },
    resetForm() {
      this.file = '';
      this.$refs.fileupload.value = null;
      this.filename = '';
    },
    onChange(e) {
      this.filename = '';
      this.message = '';
      this.success = false;
      this.file = e.target.files[0];
      this.filename = this.file.name;
    },
    formSubmit(e) {
      e.preventDefault();
      let existingObj = this;
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      let data = new FormData();
      if (!this.file || this.file.length === 0) {
        return;
      }
      data.append('file', this.file);
      data.append('setting_name', this.settingName);
      axios.post('/admin-settings/update-setting', data, config)
          .then(function (res) {
            existingObj.success = res.data.success;
            existingObj.loadLastestResults();
          })
          .catch(function (err) {
            existingObj.message = 'Problem with upload.';
            existingObj.success = false;
            if (err?.message) {
              existingObj.message = err?.message;
              let message = JSON.parse(err.message);
              if (message.file?.[0]) {
                existingObj.message = '';
                existingObj.message = message.file[0];
              }
            }
            existingObj.message += '  The records have not change.';
          });
      this.resetForm();
    }
  }
}
</script>